<template>
  <div id="select-tariff-pgk"
       class="block block__column block__theme_tariff"
  >
    <SwitchComponent
      class="block-switch"
      :firstName="'1 уровень'"
      :secondName="'4 уровня'"
      :firstNameMobile="'1 уровень'"
      :secondNameMobile="'4 уровня'"
      v-model:firstSwitchActive="isFirstSwitchActive"
      @changeSwitch="changeSwitch"
    ></SwitchComponent>

<!--    <CourseInfo
      class="course-info"
      :idSelectedTariff="idSelectedTariff"
      :listTariff="listTariff"
      :firstSwitchActive="isFirstSwitchActive"
      @changeTariff="changeTariff"
    ></CourseInfo>-->

    <MobilePromoCodeComponent
      class="mobile-promocode"
      :promoCodeApplied="promoCodeApplied"
      v-model:promoCode="valuePromoCode"
      @applyPromoCode="applyPromoCode"
      @removePromoCode="removePromoCode"
    ></MobilePromoCodeComponent>

    <TariffTable
      v-model:firstSwitchActive="isFirstSwitchActive"
      :idSelectedTariff="idSelectedTariff"
      :listTariff="listTariff"
      :featureList="featureList"
      @changeTariff="changeTariff"
    ></TariffTable>
  </div>
</template>

<script>
import SwitchComponent from "./ComposablesSelectTariff/SwitchComponent";
import MobilePromoCodeComponent from "./ComposablesSelectTariff/MobilePromoCodeComponent";
import TariffTable from "./ComposablesSelectTariff/TariffTable";

export default {
  name: "PGKSelectTariff",

  props: {
    promoCodeApplied: { // применен промокод?
      type: Boolean,
      default: () => {
        return false
      }
    },

    promoCode: { // текст промокода
      type: String,
      default: () => {
        return ''
      }
    },

    idSelectedTariff: { // id выбранного курса
      type: Number,
      default: () => {
        return 0
      },
    },

    firstSwitchActive: { // активен первый switch?
      type: Boolean,
      default: () => {
        return false
      }
    },

    listTariff: { // список курсов
      type: Array,
      default: () => {
        return []
      },
    },

    featureList: { // список особенностей тарифов
      type: Array,
      default: () => {
        return []
      }
    },
  },

  data() {
    return {

    }
  },

  created() {
    console.log('promoCode', this.valuePromoCode)
  },

  mounted() {

  },

  watch: {

  },

  methods: {
    /** Установить тип репетитора
     * @param {Boolean} isFirstsSelected - выбран первый элемент?
     * */
    changeSwitch(isFirstsSelected) {
      this.$emit('changeSwitch', isFirstsSelected);
    },

    /** Сменить тариф
     * @param {Number} idTariff - id выбираемого тарифа
     * */
    changeTariff(idTariff) {
      this.$emit('changeTariff', idTariff);
    },

    /** Применить промокод
     * */
    applyPromoCode() {
      this.$emit('applyPromoCode');
    },

    /** Удалить промокод
     * */
    removePromoCode() {
      this.$emit('removePromoCode');
    },
  },

  computed: {
    valuePromoCode: { // промокод
      get() {
        return this.promoCode
      },

      set(modelValue) {
        this.$emit('update:promoCode', modelValue);
      }
    },

    isFirstSwitchActive: { // активен первый switch?
      get() {
        return this.firstSwitchActive
      },

      set(modelValue) {
        this.$emit('update:firstSwitchActive', modelValue);
      },
    }
  },

  components: {
    SwitchComponent,
    MobilePromoCodeComponent,
    TariffTable,
  },
}
</script>

<style scoped lang="scss">
@import "../../../../../../style/variables";

.block__theme_tariff {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px 32px;
  background-color: white;
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 16px;
}

.course-info {
  margin-top: 24px;
  width: 100%;
}

.mobile-promocode {
  display: none;
}

@media all and (max-width: 1600px) {
  .block__theme_tariff {
    padding: 36px 28px;
  }
}

@media all and (max-width: 1440px) {
  .block__theme_tariff {
    padding: 34px 26px;
  }

  .course-info {
    margin-top: 22px;
  }
}

@media all and (max-width: 1280px) {
  .block__theme_tariff {
    padding: 32px 24px;
  }
}

// tablet
@media all and (max-width: 1160px) {
  .mobile-promocode {
    display: flex;
    margin-top: 22px;
  }
}

@media all and (max-width: 960px) {

}

@media all and (max-width: 780px) {
  .block__theme_tariff {
    padding: 30px 20px;
  }
}

@media all and (max-width: 720px) {
  .block__theme_tariff {
    padding: 28px 20px;
  }
}

// mobile
@media all and (max-width: 600px) {
  .block__theme_tariff {
    padding: 0;
    background: rgba(255, 255, 255, 0);
    border: none;
    border-radius: 0;
  }

  .course-info {
    margin-top: 16px;
  }

  .mobile-promocode {
    margin-top: 16px;
  }
}
</style>